import { useContext } from 'react'
import uniqid from 'uniqid'
import { LanguageContext } from '../../contexts/language'
import './Skills.css'

const Skills = () => {
  const { portfolio, t } = useContext(LanguageContext)
  const { skills } = portfolio

  if (!skills.length) return null

  return (
    <section className='section skills' id='skills'>
      <h2 className='section__title'>{t.skills}</h2>
      <ul className='skills__list'>
        {skills.map((skill) => (
          <li key={uniqid()} className='skills__list-item btn btn--plain'>
            {skill}
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Skills
